import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";

Vue.use(VueRouter);
import appConfig from "appConfig";

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/details/:orderNumber?",
    name: "Details",
    component: () => import("../views/Details.vue"),
  },
  {
    path: "*",
    name: "Home",
    component: Home,
  },
];

const router = new VueRouter({
  base: appConfig.BASE_URI || "/",
  routes,
});

export default router;
